import {
  Box,
  capitalize,
  ChevronSmall,
  convert24HourTo12Hour,
  DeleteIcon,
  DeliveryAssignmentNonOperatingConditionsEntity,
  Div,
  EditPenIconRed,
  H5,
  Icon,
  Img,
  P,
  renderMiles,
  renderProviderIcon,
  renderProviderName,
  Separator,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useRef, useState } from 'react';
import { Collapsible } from '../../VDriveLocation';

export const AssignmentNonOperatingCondition = ({
  item,
  setNonOperatingConditions,
  index,
  setEditNonOperatingConditions,
}: {
  item: DeliveryAssignmentNonOperatingConditionsEntity;
  setNonOperatingConditions: Dispatch<
    SetStateAction<DeliveryAssignmentNonOperatingConditionsEntity[]>
  >;
  index: number;
  setEditNonOperatingConditions: Dispatch<
    SetStateAction<
      | boolean
      | { item: DeliveryAssignmentNonOperatingConditionsEntity; index: number }
    >
  >;
}) => {
  const [collapse, setCollapse] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const elementHeight = ref?.current?.clientHeight;

  const { day, distanceMiles, startTime, endTime, orderProvider } = item;

  const handleDeleteItem = () => {
    setNonOperatingConditions((prev) => prev.filter((_, i) => i !== index));
  };

  const handleEditItem = () => {
    setEditNonOperatingConditions({ item, index });
  };

  return (
    <Box $flex $justifyCenter $between $column>
      <Div $pointer $flex $alignCenter $between>
        <H5 onClick={() => setCollapse((prev) => !prev)} $mb="0">
          {capitalize(day || '')}
        </H5>
        <Div $flex $alignCenter $gap="16px">
          <Icon $size="32" onClick={handleEditItem}>
            <EditPenIconRed />
          </Icon>
          <Icon $size="32" onClick={handleDeleteItem}>
            <DeleteIcon />
          </Icon>
          <Icon
            $rotate={collapse ? '180deg' : '0'}
            onClick={() => setCollapse((prev) => !prev)}
          >
            <ChevronSmall />
          </Icon>
        </Div>
      </Div>
      <Collapsible expanded={collapse} elementHeight={elementHeight}>
        <Div ref={ref} $flex $column $gap="4px">
          <Separator $m="0 0 12px 0" />
          <P $m="0">Distance Condition:</P>
          <H5 $m="0">
            {distanceMiles
              ? `Under ${distanceMiles} ${renderMiles(distanceMiles)}`
              : '-'}
          </H5>
          <Separator $m="12px 0" />
          <P $m="0">Time Condition:</P>
          <H5 $m="0">
            {convert24HourTo12Hour(startTime)} -{' '}
            {convert24HourTo12Hour(endTime)}
          </H5>
          <Separator $m="12px 0" />
          <Div $flex $alignCenter $between>
            <Div>
              <P $m="0">Order Provider Condition:</P>
              <H5 $m="0">
                {orderProvider ? renderProviderName(orderProvider) : '-'}
              </H5>
            </Div>
            <Img
              alt=""
              src={renderProviderIcon(orderProvider || '')}
              $width="32px"
              $widthSM="32px"
            />
          </Div>
        </Div>
      </Collapsible>
    </Box>
  );
};
